import { TransferState, inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { map, of } from 'rxjs';

export const exploreHostelsResolver: ResolveFn<any> = (route, state) => {
  const ssrData = inject(TransferState);

  if (ssrData?.['EXPLORE_PAGE_DATA']) {
    return of(ssrData['EXPLORE_PAGE_DATA'].data);
  } 
  return null;
};
